import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { WatchStatus } from './watch-status.interface';
import { WatchStatusService } from './watch-status.service';
const service = new WatchStatusService();

export interface WatchStatusState {
   watchStatuses: Array<WatchStatus>;
}

const WatchStatusStore: Module<WatchStatusState, StoreState> = {
   namespaced: true,
   state: {
      watchStatuses: [],
   },
   getters: {},
   mutations: {
      SET_WATCH_STATUSES(state, watchStatuses: Array<WatchStatus>) {
         state.watchStatuses = watchStatuses;
      },
   },
   actions: {
      async getWatchStatuses({ commit }) {
         const watchStatuses = await service.getWatchStatuses();
         commit('SET_WATCH_STATUSES', watchStatuses);
         return watchStatuses;
      },
   },
};

export default WatchStatusStore;
